/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectFileDto } from '../../models/backend-project-file-dto';
import { BackendProjectFileRequestDto } from '../../models/backend-project-file-request-dto';

export interface ProjectsProjectsFilesCreate$FormData$Params {
  body: BackendProjectFileRequestDto;
}

export function projectsProjectsFilesCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectsFilesCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectFileDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsFilesCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectFileDto>;
    }),
  );
}

projectsProjectsFilesCreate$FormData.PATH = '/api/projects/projects/files/';
